enum RoleType {
  Carer = 'Carer',
  CareRecipient = 'CareRecipient'
}

export { RoleType };
